import React from "react";
import AboutUsUserCard from "../../../AboutUs/Sections/AboutFounderMessage/Components/AboutUsUserCard";

const CareersFounderMessageSection = () => {
  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Background Image Container with Dual Shadows */}
      <div className="absolute inset-0">
        {/* Top Shadow Gradient */}
        <div className="absolute top-0 left-0 right-0 h-14 md:h-40 z-10 bg-gradient-to-b from-app-background to-transparent"></div>

        {/* Main Image */}
        <img
          src="/images/careers-page/careers-image-2.jpeg"
          alt="Founder Message"
          className="w-full h-full object-cover object-center grayscale opacity-30"
        />

        {/* Bottom Shadow Gradient */}
        <div className="absolute bottom-0 left-0 right-0 h-40 z-10 bg-gradient-to-t from-app-background to-transparent"></div>
      </div>

      {/* Text Content */}
      <div className="relative z-20 flex flex-col justify-center items-start md:items-center h-full text-start md:text-center px-4 md:px-20 md:py-36">
        <p className="text-2xl md:text-5xl font-bold text-white mb-4 drop-shadow-lg leading-normal tracking-wide">
          “We are forged from the same stardust that forms the cosmos, a
          testament to the boundless possibilities of the universe. Yet, as we
          gaze outward, we are reminded of our fragility—a fleeting existence on
          a pale blue dot. Inspired by this duality, we create AI solutions that
          embrace infinite potential while staying grounded in purpose and
          humility.”
        </p>
        <AboutUsUserCard
          className="mt-4 md:mt-12"
          userProfilePic="/images/about-us-page/founder-image.jpg"
          username="Gaurav Dixit"
          position="Founder & CEO, Datapixl"
        />
      </div>
    </div>
  );
};

export default CareersFounderMessageSection;
